module.exports = __webpack_public_path__ + "static/media/marker--priority-red.f5151e69.svg";